export default __webpack_public_path__ + "img/ibn.fd81d536.png";